import { MDBAutocomplete, MDBBtn, MDBIcon, MDBModalFooter, MDBSpinner } from "mdb-react-ui-kit";
import ReactDOM from "react-dom";
import { forwardRef, useEffect, useRef, useState } from "react";
import { Controller, useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router";
import { creatAAGroup, getMisc } from "../../../apiclients/streamsapi_bridge";
import { customSearch } from "../../../components/CustomSearchUtil/CustomSearch";

const AddAAGroup = forwardRef((props, ref) => {
  const { t } = useTranslation();
  const [autoext, setAutoext] = useState(true);
  const [extCheckFlag, setextCheckFlag] = useState(0);
  const [checkAvailbility, setCheckAvailbility] = useState("");
  const [operators, setoperators] = useState([]);
  const [displayValue, setdisplayValue] = useState([]);
  const [isUpdateDest, setIsUpdateDest] = useState(false);
  const [destinationValue, setDestinationValue] = useState("");
  const [updateDest, setUpdateDest] = useState({});
  const [userList, setuserList] = useState([]);
  const [hgList, sethgList] = useState([]);
  const [selectedType, setSelectedType] = useState(null);
  const [selectedValue, setSelectedValue] = useState(null);
  const [searchTerm, setSearchTerm] = useState("");
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [dropdownPosition, setDropdownPosition] = useState({ top: 0, left: 0, width: 0 });


  const dropdownRef = useRef();
  const portalDropdownRef = useRef(null);

  const operatorType =
    { "Users": 2, "Hunt Groups": 1 }

  const dummyData = {
    Users: userList,
    "Hunt Groups": hgList,
  };


  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        dropdownRef.current &&
        !dropdownRef.current.contains(event.target) &&
        portalDropdownRef.current &&
        !portalDropdownRef.current.contains(event.target)
      ) {
        setIsDropdownOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  useEffect(() => {
    if (isDropdownOpen && dropdownRef.current) {
      const rect = dropdownRef.current.getBoundingClientRect();
      setDropdownPosition({
        top: rect.bottom + window.scrollY,
        left: rect.left + window.scrollX,
        width: rect.width,
      });
    }
  }, [isDropdownOpen]);


  let filteredOptions =
    selectedType
      ? customSearch(
        dummyData[selectedType],
        searchTerm,
        ["title", "extensions"] // search in both title and extensions
      )
      : [];
  //const [isloading, setIsloading] = useState(false);
  // const [error, setError] = useState({});
  const thName = useRef();
  const { register, handleSubmit, getValues, setValue, setError, formState, clearErrors, watch, control } =
    useForm({
      defaultValues: {
        name: "",
        extension: "",
      },
    });
  const { errors, isDirty } = formState;

  const navigate = useNavigate();

  const onsubmit = async (data) => {
    let updates = {};
    if (isDirty) {
      setCheckAvailbility(false);
      let updates = {};
      updates = {
        reqid: 24,
        siteid: JSON.parse(sessionStorage.getItem("admin_session")).siteid,
        name: data.name,
        extension: parseInt(data.extension),
        // operator: data.operator,
      };
      props.setIsloading(true);
      let saverep = await creatAAGroup(updates);
      setTimeout(() => {
        props.setIsloading(false);
      }, 2000);
      let saverepeMsg = await saverep.json();
      console.log(saverepeMsg);
      if (saverepeMsg.status && saverepeMsg.status == "success") {
        if (props.destination && props.destination === "callflow") {
          localStorage.setItem(
            "s_message",
            "Group " + data.name + " created successfully. Please refresh the page to use the newly created group."
          );
          window.close()
        } else {
          localStorage.setItem(
            "s_message",
            "Auto-Attendant Group " + data.name + " created successfully."
          );
        }

        props.onClose();
        if (props.onSuccess) {
          props.onSuccess({ ...saverepeMsg, name: data.name , extension : data?.extension }, props.tnode);
          return;
        } else {
          window.location.href = "/autoattendant";
        }
      } else {
        if (saverepeMsg.message?.errors) {
          saverepeMsg.message.errors.forEach((err) => {
            setError(err.param_name, {
              type: "server",
              message: err.message,
            });
            const fieldElement = document.querySelector(
              `input[name="${err.param_name}"]`
            );
            if (fieldElement) {
              fieldElement.focus();
            }
          });
        } else {
          localStorage.setItem("f_message", saverepeMsg.message);
          window.location.href = "/autoattendant";
        }
      }
    }
  };

  // async function fetchData() {
  //   console.log(sessionStorage.getItem("admin_session"));
  //   const response = await getMisc(
  //     JSON.parse(sessionStorage.getItem("admin_session")).siteid,
  //     {
  //       misc: ["hopmisc"],
  //     }
  //   );
  //   if (!response.json) {
  //     const message = `An error has occured: ${response.statusText}`;
  //     return;
  //   }
  //   const tdata = await response.json();
  //   if (!tdata) {
  //     window.alert(`info with id  not found`);
  //     navigate("/");
  //   }
  //   console.log("tdata :::::::::::::: " + JSON.stringify(tdata));
  //   setuserList((tdata?.misc?.hopmisc?.user ?? []).sort((a, b) => a?.title?.localeCompare(b?.title)));
  //   sethgList((tdata?.misc?.hopmisc?.hg ?? []).sort((a, b) => a?.title?.localeCompare(b?.title)));
  //   setacdList((tdata?.misc?.hopmisc?.acd ?? []).sort((a, b) => a?.title?.localeCompare(b?.title)));


  // }
  // useEffect(() => {
  //   fetchData();
  // }, []);

  async function checkAvailability(e) {
    if (e.target.value.trim() == "") {
      return;
    }
    setextCheckFlag(1);
    console.log(sessionStorage.getItem("admin_session"));
    const response = await getMisc(
      JSON.parse(sessionStorage.getItem("admin_session")).siteid,
      { check_ext: e.target.value }
    );
    console.log(response);
    if (!response.json) {
      const message = `An error has occured: ${response.statusText}`;
      return;
    }
    const tdata = await response.json();
    if (!tdata) {
      window.alert(`info with id  not found`);
      navigate("/");
    }
    if (tdata.check_ext) {
      setCheckAvailbility(true);
      setError("extension", { message: "Extension is available" });
    } else {
      setCheckAvailbility(false);
      setError("extension", { message: "Extension is not available" });
    }
    console.log(tdata);
  }

  const onSearch = (value) => {
    const lowercasedValue = value.toLowerCase().trim();

    if (lowercasedValue !== "") {
      // Split the input by ':' to handle both individual and compound searches
      const searchTerms = lowercasedValue.split(':').map(term => term.trim());

      let filteredData = [];
      searchTerms.forEach(term => {
        filteredData = customSearch(operators, term, ['title', 'extensions']);
      });


      if (filteredData.length === 0) {

        setdisplayValue(filteredData);



      } else {

        setdisplayValue(filteredData);

      }
    } else {
      setdisplayValue([]);
    }
  }

  function validateTheSelect(value) {


    setIsUpdateDest(true);
  }

  function handleChange(value) {
    setDestinationValue(value);
    const extension = value.includes(":") ? value.split(":")[1].trim() : 0;
    let updateObj = {};

    const matchedItem = operators.find(
      (item) => parseInt(item.extensions, 10) === parseInt(extension, 10)
    );

    if (matchedItem) {
      const { id, code, agentid } = matchedItem;

      const destination = id ? 2 : 1;
      updateObj = {
        value: destination === 2 ? agentid + "" : code + "",
        type: destination
      };

    }


    setUpdateDest(updateObj);
  }

  useEffect(() => {
    if (isUpdateDest && updateDest) {
      setValue("operator", updateDest, { shouldDirty: true })
      setUpdateDest({});
      setIsUpdateDest(false);
    }
  }, [updateDest, isUpdateDest]);


  async function validateOperator() {
    const operator = watch("operator");
    if (!operator || Object.keys(operator).length === 0) {
      setError("operator", { message: "Operator should not be empty" });
    }
  }
  const handleMainTypeClick = (e, type, typeid) => {
    e.preventDefault();
    e.stopPropagation();
    console.log("Selected Type:", type);
    setSelectedType(type);

    // Close dropdown if the type has no options
    if (dummyData[type].length === 0) {
      setSelectedValue(type);
      setIsDropdownOpen(false);
    } else {
      setSearchTerm("");
    }
    setValue("operator.type", typeid, { shouldDirty: true });
  };


  const handleBack = () => {
    setSelectedType(null);
    setSearchTerm("");
  };

  const handleOperatorSelect = (item) => {
    setSelectedValue(item.title + "" + (item.extensions ? ` : ${item.extensions}` : ""));
    setIsDropdownOpen(false);
    const { id, code, agentid } = item;
    setValue("operator.type", agentid ? 2 : 1, { shouldDirty: true });
    setValue("operator.value", agentid ?? code + "", { shouldDirty: true });
  }

  const [typingTimeout, setTypingTimeout] = useState(null);
  useEffect(() => {
    return () => {
      if (typingTimeout) {
        clearTimeout(typingTimeout);
      }
    };
  }, [typingTimeout]);


  return (
    <>
      {/* <MDBModal
                    open={AddAutoAttendant}
                    setShow={setAddAutoAttendant}
                    tabIndex="-1"
                  >
                    <MDBModalDialog>
                      <MDBModalContent>
                        <MDBModalHeader>
                          <MDBModalTitle>
                            {t("addAutoAttendant")}
                          </MDBModalTitle>
                          <MDBBtn
                            className="btn-close"
                            color="none"
                            onClick={toggleShow11}
                          ></MDBBtn>
                        </MDBModalHeader>
                        <MDBModalBody>
                          <div>
                            <div className="tel-numbers">
                              <strong>{t("autoAttendantName")}</strong>
                            </div>
                            <div className="form pt-1">
                              <input
                                type="text"
                                className="form-control"
                                value="Main Open AA"
                              />
                            </div>
                            <div className="tel-numbers mt-2">
                              <strong>{t("extension")}</strong>
                            </div>
                            <div className="form pt-1">
                              <input
                                type="text"
                                className="form-control"
                                value="5000"
                              />
                            </div>
                          </div>
                        </MDBModalBody>
                        <MDBModalFooter>
                          <MDBBtn color="secondary" onClick={toggleShow11}>
                            {t("close")}
                          </MDBBtn>
                          <MDBBtn>{t("add")}</MDBBtn>
                        </MDBModalFooter>
                      </MDBModalContent>
                    </MDBModalDialog>
                  </MDBModal>*/}
      {/* {isloading && (
        <>
          <div className="loadingclass">
            <MDBBtn disabled>
              <MDBSpinner size="sm" role="status" tag="span" className="me-2" />
              Loading...
            </MDBBtn>
          </div>
        </>
      )} */}
      <div>
        <div className="tel-numbers">
          <strong>{t("autoAttendantName")}</strong>
        </div>
        <form>
          <div className="form pt-1">
            <input
              type="text"
              maxLength={18}
              className="form-control"
              {...register("name", { required: "Name is required" })}
            />
            {errors.name && (
              <p className="text-danger">{errors.name.message}</p>
            )}
          </div>
          <div className="row">
            <div className="pt-2">
              <div className="tel-numbers mt-2">
                <strong>{t("extension")}</strong>
              </div>

              <input
                type="text"
                maxLength={5}
                className="w-100 form-control"
                onKeyPress={(event) => {
                  if (!/[0-9]/.test(event.key)) {
                    event.preventDefault();
                  }
                }}
                {...register("extension", {
                  required: "Extension is required",
                })}
                onChange={(e) => {
                  e.preventDefault();
                  if (!/^\d+$/.test(e.target.value)) {
                    setCheckAvailbility(false);
                    setError("extension", { message: "Extension is required and must be numeric" });
                  } else if (e.target.value.length >= 3 && e.target.value.length <= 5) {
                    if (e.target.value.charAt(0) === "0") {
                      setCheckAvailbility(false);
                      setError("extension", { message: "An extension cannot begin with zero(0)" });
                    } else {
                      checkAvailability(e);
                    }
                  } else {
                    setCheckAvailbility(false);
                    clearErrors("extension");
                  }
                }}
              />
              {errors.extension && (
                <>
                  {!checkAvailbility && (
                    <>
                      <p className="text-danger">{errors.extension.message}</p>
                    </>
                  )}

                  {checkAvailbility && (
                    <p style={{ color: "Green" }} className="clr-red">
                      {errors.extension.message}
                    </p>
                  )}
                </>
              )}
            </div>
          </div>
          {/* <div className="tel-numbers mt-3">
            <strong>Operator</strong>
          </div>

          <Controller
            name="operator.type"
            control={control}
            rules={{
              validate: (value) => {
                // If no operator is selected (value is empty or hop_type is 0)
                if (!value || value.type === 0 || !selectedValue) {
                  return "Operator is required";
                }
                return true;
              }
            }} render={({ field }) => (
              <>
                <div className="custom-selector w-100" ref={dropdownRef}>
                  <div
                    className="custom-selector-box form-select position-relative"
                    onClick={(e) => {
                      clearErrors("operator.type");
                      // setSelectedValue(null);
                      setSelectedType(null);
                      setSearchTerm("");
                      setIsDropdownOpen(!isDropdownOpen);
                    }}
                  >
                    {selectedValue || "Select Operator"}
                  </div>
                  {isDropdownOpen &&
                    ReactDOM.createPortal(
                      <div
                        className="custom-selector-dropdown"
                        ref={portalDropdownRef}
                        style={{
                          top: dropdownPosition.top,
                          left: dropdownPosition.left,
                          width: dropdownPosition.width,
                          zIndex: 9999,
                        }}
                      >
                        <div className="custom-selector-dropdown">
                          {!selectedType ? (
                            <>

                              <div className="custom-selector-options">
                                {Object.keys(dummyData).map((type) => (
                                  <div
                                    key={type}
                                    className="custom-selector-option"
                                    onClick={(e) => {
                                      field.onChange(operatorType[type]);
                                      handleMainTypeClick(e, type, operatorType[type]);
                                    }
                                    }
                                  >
                                    {type}
                                  </div>
                                ))}
                              </div>

                            </>

                          ) : (
                            <>
                              {operatorType[selectedType] && operatorType[selectedType] !== 3 && (<>
                                <div className="custom-selector-suboptions">
                                  <div className="top-bar">
                                    <input
                                      autoFocus
                                      type="text"
                                      placeholder={`Search ${selectedType}`}
                                      value={searchTerm}
                                      onChange={(e) => setSearchTerm(e.target.value)}
                                    />
                                    {searchTerm && (
                                      <MDBIcon fas icon="times" className="px-2 close-icon" color='danger' onClick={() => setSearchTerm("")} />
                                    )}
                                  </div>
                                  <div className="suboptions-list">
                                    {filteredOptions.length > 0 ? (
                                      filteredOptions.map((item) => (
                                        <div
                                          key={item.extensions}
                                          className="custom-selector-option"
                                          onClick={() => {
                                            handleOperatorSelect(item);

                                          }}
                                        >
                                          {item.title}{item.extensions ? ` : ${item.extensions}` : ""}
                                        </div>
                                      ))
                                    ) : (
                                      <div className="custom-selector-option">No results found</div>
                                    )}
                                  </div>
                                  <MDBModalFooter className="py-2 pe-2">
                                    <MDBBtn size='sm' className="back-btn" onClick={handleBack}>
                                      Back
                                    </MDBBtn>

                                  </MDBModalFooter>
                                </div>
                              </>
                              )}
                            </>
                          )}
                        </div>

                      </div>,
                      document.body
                    )}

                </div>
                {errors?.operator?.type && (
                  <p className="text-danger">{errors?.operator?.type.message}</p>
                )}
              </>
            )}

          /> */}

          <br />

          <div style={{ display: "none" }}>
            <button ref={ref} onClick={(e) => { e.preventDefault(); 
              // validateOperator(); 
              handleSubmit(onsubmit)() }}>
              {t("add")}</button>
          </div>

          {/* <MDBModalFooter>
            <MDBBtn color="secondary" onClick={props.onClose}>
              {t("close")}
            </MDBBtn>
            <MDBBtn
              onClick={(e) => {
                e.preventDefault();
                handleSubmit(onsubmit)();
              }}
            >
              {t("add")}
            </MDBBtn>
          </MDBModalFooter> */}
        </form>
      </div>
    </>
  );
});

export default AddAAGroup
